namespace appn.views.data.feed {
    class InitArgs {
        dataFeedPageSize: number = 0;
        dateFilter: string = emptyString;
        userFilterId: number = 0;
        formFilterId: Guid = emptyGuid;
        dataFeedAjax: string = emptyString;
    }

    let _initArgs: InitArgs;

    let _timeLineCount: JQuery<HTMLElement>;
    let _currentResultCount: number = 0;
    let _currentPageNumber: number = 0;
    let _map: L.Map;
    let _searchValue: string;
    let _error: JQuery<HTMLElement>;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.dateFilterMini.init(_initArgs.dateFilter, requestDataFeedAjax);

        addEvents();

        requestDataFeedAjax();

        // On Page load for first time we have to check this due to saveMeState
        // This is to protect our db from expensive calls (a month worth of all form entries for all users)
        enableDisableSearchBox();

        // Only do this once on load to avoid applying styling multiple times
        $('.feed-search-container').append(appn.popover.hint(emptyString, T('Filter results where the selected forms <b>Answers</b> start with a keyword typed in here.'), 'datafeed-hint-input-right'));

        appn.popover.init();

        _timeLineCount = $('div.feed-result-count');

        appn.saveMeState.init(function (element: HTMLElement) {
            if (element) {
                // Ignore incoming URL filter value if user changes it manually.
                if (element.id === "UserFilterId")
                    _initArgs.userFilterId = 0;
                else if (element.id === "FormFilterId")
                    _initArgs.formFilterId = emptyGuid;
            }

            enableDisableSearchBox();
            _currentPageNumber = 0;
            _currentResultCount = 0;
            setResultCount(0);
            requestDataFeedAjax();
        },
        function() {
                _currentPageNumber = 0;
                _currentResultCount = 0;
                setResultCount(0);
                requestDataFeedAjax();
            }, '.reset-filters-container-feed');

        select.init();
        select.init({ selector: '#UserFilterId', minimumResultsForSearch: '25' }) // Start displaying 'search' at 25 items
    }

    appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function(channel: string, data: any) {
        if (!_map)
            return;

        _map.invalidateSize();
    });

    function addEvents() {
        // Since this is a custom search we need to also reset the page number and clear the timeline
        $('#SearchId').off().on('keydown', function (event) {
            if (!(event.keyCode === 13) || !event.target || !((event.target as any).type === 'search'))
                return;

            event.preventDefault();
            _searchValue = $('#SearchId').val() as string;
            $('#SearchId').blur();
            _currentPageNumber = 0;
            _currentResultCount = 0;
            setResultCount(0);

            requestDataFeedAjax();
        });
    }

    function addTimelineEvents() {
        $('.btn.load-more-data').off().on('click', function() {
            _currentPageNumber++;
            requestDataFeedAjax(true);
        });

        $('.btn-show-map').on('click', function (this: HTMLElement, e: Event) {
            e.preventDefault();

            const timeLineItem = $(this).closest('.timeline-item');
            const lat = $(this).data('maplat');
            const long = $(this).data('maplong');
            const mapId = $(this).data('mapid');

            const timeLineItemHeader = timeLineItem.find('.timeline-header');
            timeLineItemHeader.addClass('timeline-header-no-border');

            timeLineItem.find('.timeline-body').removeClass('d-none');

            initmap(mapId, lat, long);

            const timelineItemHeight = 100;
            timeLineItem.find('.leaflet-container').css('height', timelineItemHeight + 'px');

            _map.invalidateSize();
            
            $(this).remove();
        });

        appn.dialog.singleEntryExport.init();
    }

    function enableDisableSearchBox() {
        const currentSelectedForm = $('#FormFilterId option:selected');

        if (currentSelectedForm.val())
            appn.ui.enableElement($('#SearchId'));
        else {
            $('#SearchId').val(emptyString);
            appn.ui.disableElement($('#SearchId'));
        }
    }

    function requestDataFeedAjax(isRequestMore: boolean = false) {
        appn.dialog.showLoading();
        const timeline = $('div.timeline');

        if (!isRequestMore) // At this point we assume that a filter called to action and we want to null out counters
            _currentResultCount = 0;

        if (_currentPageNumber === 0) // Only clear all if this is the first page otherwise append more results
            timeline.html(emptyString);
        else 
            $('.timelineend, .load-more, .timelinespinning').remove();

        let url = _initArgs.dataFeedAjax + '?v=' + new Date().getTime();

        // Date Filter
        const appnDateFilterValue = appn.dateFilterMini.getStateOrDefault();
        url += `&DateFilter=${appnDateFilterValue.type}`;
        url += `&fromDate=${appnDateFilterValue.fromDate}`;
        url += `&toDate=${appnDateFilterValue.toDate}`;

        // Page
        url += `&PageNumber=${_currentPageNumber}`;

        // User filter
        if (_initArgs.userFilterId > 0) {
            url += `&UserFilterId=${_initArgs.userFilterId}`;
            appn.saveMeState.resetState();
        }
        else {
            const userValue = appn.dataTable.getStateOrDefault('UserFilterId', emptyString);
            if (userValue)
                url += `&UserFilterId=${userValue.value}`;
        }

        // Form filter
        if (_initArgs.formFilterId.hasValue() && _initArgs.formFilterId !== emptyGuid) {
            url += `&FormFilterId=${_initArgs.formFilterId}`;
            appn.saveMeState.resetState();
        }
        else {
            const formValue = appn.dataTable.getStateOrDefault('FormFilterId', emptyString);
            if (formValue)
                url += `&FormFilterId=${formValue.value}`;
        }

        // Search
        _searchValue = $('#SearchId').val() as string;
        if (_searchValue)
            url += `&SearchId=${encodeURIComponent(_searchValue)}`;

        appn.ajax.post({
            url: url,
            dataType: 'json',
            done: function(dataParsed: DataFeedVm) {
                $('.descreteSpin').remove();

                const userFilterText = $('#UserFilterId option:selected').text();
                const formFilterText = $('#FormFilterId option:selected').text();
                const searchFilterText = dataParsed.SearchId;
                const dateFilterText = $('.appnDateFilterMini option:selected').text() as string;
                
                if (!dataParsed.Results || dataParsed.Results.length === 0) {
                    timeline.append(getTimelineNoDataHtml(userFilterText, formFilterText, dateFilterText, searchFilterText));
                    timeline.append(getTimelineEndHtml());

                    appn.ui.tryResetFiltersEvent();

                    appn.dialog.hideLoading();
                    return;
                }

                let timelineHtmlToRender = emptyString;

                if (dataParsed.Results) {
                    // Only show the delimiters after the first batch of results
                    if (_currentPageNumber > 0)
                        timeline.append(getTimelineDelimiterHtml(_currentResultCount));

                    _currentResultCount = _currentResultCount + dataParsed.Results.length;

                    dataParsed.Results.forEach(function(result: DataFeedResult, index: number) {
                        const thisResult: DataFeedResult = result;

                        timelineHtmlToRender += getTimelineItemHtml(index, result);
                        timeline.append(timelineHtmlToRender);

                        timelineHtmlToRender = emptyString;
                    });
                }

                // Don't show load more if we have reached the total amount of possible results
                if (_currentResultCount < dataParsed.TotalRows)
                    timeline.append(getTimelineLoadMoreButton());
                else
                    timeline.append(getTimelineNoDataHtml(userFilterText, formFilterText, dateFilterText, searchFilterText));
               
                timeline.append(getTimelineEndHtml());

                ($('abbr.timeago') as any).timeago();
                appn.ui.initOpenOnClick();

                // Events needed by the timeline after load
                addTimelineEvents();

                setResultCount(_currentResultCount);

                appn.ui.tryResetFiltersEvent();

                appn.dialog.hideLoading();
            },
            fail: function() {
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Data Feed Load Failed'),
                    message: T('Failed to load feed data.  Please sign out and sign in again.  Contact support if this problem persists.'),
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    autoHeaderIcon: false
                });
                appn.dialog.hideLoading();
            },
            always: function() {
                enableDisableSearchBox();
            }
        });
    }

    function setResultCount(currentCount: number): void {
        _timeLineCount.text(T('Showing {0} results', currentCount));
    }

    function getTimelineLoadMoreButton() {
        const btn = elementBuilder.createElement('button', ['load-more-data', 'btn', 'btn-info'], undefined, undefined,
            `${elementBuilder.createElement('i', ['fa', 'fa-sync-alt']).outerHTML} ${T('Load More Results')}`);
        const item = elementBuilder.createElement('div', ['time-label', 'center-block', 'load-more']);
        item.append(btn);

        return item.outerHTML;

    }

    function hasLongAndLat(result: DataFeedResult) {
        return result.FormEntryDeets.Latitude !== 0 && result.FormEntryDeets.Longitude !== 0;
    }

    function hasTask(result: DataFeedResult) {
        return result.FormEntryDeets.TaskId;
    }

    function getTimelineItemHtml(ii: number, dataFeedResult: DataFeedResult) {
        let fileHtml = appn.emptyString;
        if (dataFeedResult.FilesTotalDisplay > 0)
            fileHtml = '<span class="datafeed-mediafiles">' + (dataFeedResult.FilesUpLoadedDisplay === dataFeedResult.FilesTotalDisplay ? '<i class="fa fa-check text-success" ></i> ' : '<i class="fa fa-sync-alt text-warning m-1" ></i>') + T('{0} of {1} media files uploaded successfully', dataFeedResult.FilesUpLoadedDisplay, dataFeedResult.FilesTotalDisplay) + '</span>';

        let mapHtmls = appn.emptyString;

        // Just set this to default, we'll size them later
        const mapId = `map${_currentPageNumber}-${ii}`;
        if (hasLongAndLat(dataFeedResult))
            mapHtmls = `<div class="" id="${mapId}" style="height: 102px !important;"></div>`;

        let templates;
        if (dataFeedResult.TemplateFileNames && dataFeedResult.TemplateFileNames.length > 0)
            templates = JSON.stringify(dataFeedResult.TemplateFileNames);

        const mainFooterContent = buildTimelineFooterContent(dataFeedResult.ViewEntryUrl, dataFeedResult.LogsEntryUrl, dataFeedResult.ViewEntryInTable,
            mapHtmls, dataFeedResult.FormEntryDeets.Id, dataFeedResult.ReceivedTimeAgo, dataFeedResult.ReceivedOnDisplay,
            dataFeedResult.ScreenName ? dataFeedResult.ExportEntryUrl : undefined, templates, hasTask(dataFeedResult) ? dataFeedResult.TaskUrl : undefined, dataFeedResult, mapId);

        return buildTimelineItem(getFormIconHtml(dataFeedResult), dataFeedResult.CompleteBy, dataFeedResult.ViewEntryUrl, mapHtmls, mainFooterContent, dataFeedResult.ScreenName, fileHtml, dataFeedResult.ReceivedTimeAgo, dataFeedResult.ReceivedOnDisplay, dataFeedResult.FormVersion).outerHTML;
    }

    function buildTimelineItem(itemIconHTML: string, completeBy: string, link: string, itemMapHTML: string, footerContent: HTMLElement, screenName?: string, fileHTML?: string, recievedTime?: string, receivedDisplay?: string, version?: string): HTMLElement {
        const compositeIcon = elementBuilder.createElement('i', 'fa feed-timeline-image', undefined, undefined, itemIconHTML);
        const headerLink = elementBuilder.createElement('a', undefined, undefined, [['href', link], ['onclick', 'return appn.ui.popup(this)']], screenName ?? T('Form Entry'));
        const itemHeader = elementBuilder.createElement('h3', 'timeline-header', undefined, undefined,
            T('{0} completed', completeBy) + ` ${headerLink.outerHTML} <span class="text-muted font-size-smaller-3 data-feed-version">${version}</span>`);

        const itemBody = elementBuilder.createElement('div', `timeline-body p-0 d-none`);

        const itemMap = elementBuilder.createElement('div', 'feed-map-container', undefined, undefined, itemMapHTML);
        const itemRow = elementBuilder.createElement('div', 'timeline-item');
        const timeSpan = elementBuilder.createElement('span', 'time', undefined, undefined,
            `<i class="fa fa-clock"></i> ${T('Received')} <abbr class="timeago" title="${recievedTime}Z">${receivedDisplay}</abbr>`);

        itemRow.append(timeSpan);
        itemRow.append(itemHeader);
        itemRow.append(itemBody);
        if (itemMapHTML)
            itemBody.append(itemMap);

        // Footer
        const itemFooter = elementBuilder.createElement('div', 'timeline-footer pt-1');
        itemFooter.append(footerContent);
        if (fileHTML)
            itemFooter.append($.parseHTML(fileHTML)[0] as any);

        itemRow.append(itemFooter);

        const item = elementBuilder.createElement('div');
        item.append(compositeIcon);
        item.append(itemRow);

        return item;
    }

    function buildTimelineFooterContent(viewLink: string, logLink: string, tableLink: string, itemMapHTML: string, entryId: string, recievedTime: string, receivedDisplay: string, exportLink?: string, templates?: string, taskLink?: string, dataFeedResult?: DataFeedResult, mapId?: string): HTMLElement {

        const mainContainer = elementBuilder.createElement('div', '');

        if (taskLink) {
            const tskAction = elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 pl-0', undefined, [['href', taskLink ?? emptyString], ['target', '_blank'], ['rel', 'noopener noreferrer']], '<i class="fa fa-paper-plane m-1" ></i>' + T('View Related Task'));
            mainContainer.append(tskAction);
        }

        const viwAction = elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 pl-0', undefined, [['href', viewLink], ['onclick', 'return appn.ui.popup(this)']], '<i class="fa fa-eye m-1" ></i>' + T('View Entry'));
        const expAction = elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 singleEntryExportLink', undefined, [['href', exportLink ?? emptyString], ['data-entryid', entryId], ['data-templatefiles', templates ?? emptyString]], '<i class="fa fa-upload m-1" ></i>' + T('Export Data'));
        const logAction = elementBuilder.createElement('a', 'btn btn-link btn-sm py-0', undefined, [['href', 'javascript:void(null);'], ['data-modal-iframe', logLink], ['data-size', 'modal-xl']], '<i class="fa fa-history m-1" ></i>' + T('Connector Logs'));
        const tblAction = elementBuilder.createElement('a', 'btn btn-link btn-sm py-0', undefined, [['href', tableLink], ['target', '_blank'], ['rel', 'noopener noreferrer']], '<i class="fa fa-th-list m-1"></i>' + T('Table View'));

        mainContainer.append(viwAction);

        if (exportLink)
            mainContainer.append(expAction);

        mainContainer.append(logAction);
        mainContainer.append(tblAction);

        if (itemMapHTML)
            mainContainer.append(elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 btn-show-map', undefined, [['data-maplat', dataFeedResult?.FormEntryDeets.Latitude.toString() as string], ['data-maplong', dataFeedResult?.FormEntryDeets.Longitude.toString() as string], ['data-mapid', mapId as string]], '<i class="fa fa-map-marked m-1" ></i>' + T('Show Map')));

        return mainContainer;
    }

    function getFormIconHtml(dataFeedResult: DataFeedResult) {
        if (!dataFeedResult.FormIconUrl)
            return emptyString;

        return `<img class="img-fluid img-timeline-header-icon" src="${dataFeedResult.FormIconUrl}" />`;
    }

    function getTimelineDelimiterHtml(resultsAbove: number = 0) {
        return '<div class="time-label">' +
            `<span class="bg-info"><i class="fa fa-arrow-up"></i> ${T('Showing {0} results above', resultsAbove)}</span>` +
            '</div>';
    }

    function getTimelineEndHtml() {
        return '<div class="timelineend"><i class="fa fa-clock bg-navy"></i></div>';
    }

    function getTimelineNoDataHtml(userFilterText: string, formFilterText: string, dateFilterText: string, searchFilterText: string): string {

        let filtersAppliedText = T('Showing Results for:') + ` ${formFilterText}, ${userFilterText}, ${dateFilterText}`;

        if (searchFilterText && searchFilterText.length > 0)
            filtersAppliedText += `, ${T('where answers start with')} "${searchFilterText}"`;

        _error = $('.timeline-item .timeline-body h4.text-gray');
        if (_error.length > 0) {
            // Skip out if we already have it and just apply the correct text to the element
            // This prevents adding doubles
            _error.text(filtersAppliedText);
            return emptyString;
        }

        return '<div> ' +
            '<div class="timeline-item no-data-found">' +
            '<div class="timeline-body text-center text-gray lead">' +
            `<span class="font-size-larger-2"><i class="fa fa-search text-danger mr-2"></i>${_currentResultCount === 0 ? T('No Data Found') : T('No Further Data Found')}</span>` +
            `<span class="font-size-smaller-1">${filtersAppliedText}</span>` +
            `<span class="font-size-smaller-1">${T(`Try <a href='#' class='link-reset-filters'>resetting</a> the filters`)}</span>` +
            '</div>' +
            '</div>' +
            '</div>';
    }

    function initmap(mapId: string, lat: number, long: number) {
        _map = appn.ui.mapInit(mapId, lat, long, 13, true);

        const icon = L.divIcon({
            html: '<div class="appn-mapPin"></div><div class="appn-mapShadow"></div>'
        });

        const entriesll = new L.LatLng(lat, long);
        const entriesmark = new L.Marker(entriesll, { icon: icon });
        _map?.addLayer(entriesmark);
    }

    // Below this point is the interface specific to the data view model 

    interface FormEntryFile {
        Name: string;
        Uploaded: boolean;
    }

    interface FormEntryDataFeedPagedResult {
        Id: string;
        ReceivedTime: Date;
        StartTime: Date;
        CompleteTime: Date;
        CreatedDate: Date;
        UserFirstName: string;
        UserLastName: string;
        Latitude: number;
        Longitude: number;
        Files: Array<FormEntryFile>;
        ScreenKey: string;
        TaskId: string;
        FormId: string;
    }

    interface DataFeedResult {
        FormEntryDeets: FormEntryDataFeedPagedResult;
        ViewEntryUrl: string;
        ExportEntryUrl: string;
        LogsEntryUrl: string;
        ViewEntryInTable: string;
        ViewEntryInMap: string;
        TaskUrl: string;
        FormDesignUrl: string;
        CompleteTimeDisplay: string;
        ReceivedTimeAgo: string;
        ReceivedOnDisplay: string;
        StartedOnDisplay: string;
        CreatedOnDisplay: string;
        FilesUpLoadedDisplay: number;
        FilesTotalDisplay: number;
        ImageUrls: Array<string>;
        VideoUrls: Array<string>;
        AudioUrls: Array<string>;
        ScreenName: string;
        TaskName: string;
        TemplateFileNames: Array<AppnSelectListItem>;
        CompleteBy: string;
        FormVersion: string;
        FormIconUrl: string;
    }

    interface DataFeedVm {
        DateFilter: string;
        FromDate: Date;
        ToDate: Date;
        UserFilterId: number;
        Results: Array<DataFeedResult>;
        PageNumber: number;
        UserList: Array<AppnSelectListItem>;
        FormsList: Array<SelectListItem>;
        FormFilterId: string;
        SearchId: string;
        TemplateFileNames: Array<AppnSelectListItem>;
        SelectedTemplate: string;
        FileName: string;
        EmailConnectorAttachmentNames: Array<SelectListItem>;
        ExportAsPdf: boolean;
        ShowErrors: boolean;
        HighResImages: boolean;
        IsProtectData: boolean;
        EmbedImageLinks: boolean;
        DisableTimestamp: boolean;
        DisableRandomCode: boolean;
        TotalRows: number;
    }
}
